import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatLegacyFormFieldAppearance as MatFormFieldAppearance } from '@angular/material/legacy-form-field';
import { AbstractFormFieldComponent } from '@shared/form-fields/abstract-form-field/abstract-form-field.component';
import { makeProvider } from '@shared/form-fields/make-provider';

@Component({
    selector: 'app-input-colour',
    styleUrls: ['./colour-input.component.scss'],
    template: `
        <mat-form-field [appearance]="appearance">
            <mat-label *ngIf="label">
                {{ label }}
            </mat-label>

            <div matPrefix>
                <ng-content select="[appPrefix]"></ng-content>
            </div>

            <input
                type="color"
                #input
                matInput
                [(ngModel)]="value"
                [ngModelOptions]="{ standalone: true }"
                [placeholder]="placeholder"
                [disabled]="disabled"
                [readonly]="readonly"
                [required]="required"
                [tabIndex]="tabIndex"
                (keydown)="_onKeyDown($event)"
                (blur)="_onBlur()">

            <div matSuffix>
                <ng-content select="[appSuffix]"></ng-content>
            </div>

            <mat-hint *ngIf="hint">
                {{ hint }}
            </mat-hint>

            <mat-error *ngFor="let message of errorMessages">{{ message }}</mat-error>
        </mat-form-field>
    `,
    providers: [makeProvider(ColourInputComponent)],
})
export class ColourInputComponent extends AbstractFormFieldComponent<string> {
    @ViewChild('input') input: ElementRef<HTMLInputElement>;

    @Input() appearance: MatFormFieldAppearance = 'outline';

    // eslint-disable-next-line @angular-eslint/no-output-native
    @Output() blur = new EventEmitter<void>();

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onEnter = new EventEmitter<KeyboardEvent>();

    _onBlur() {
        this._onTouch();

        this.blur.emit();
    }

    blurInput() {
        this.input?.nativeElement?.blur();
    }

    _onKeyDown($event: KeyboardEvent) {
        if ($event.key === 'Enter') {
            this.onEnter.emit($event);
        }
    }
}
